import type { NoContext } from '~/services/api/contracts/NoContext'
import { PartnerUserInvitationAccept } from '~/services/api/contracts/requests/PartnerUserInvitationAccept'

// AcceptPartnerUserInviteRequest::prepareForValidation
export const PartnerUserInvitationAcceptOrganizer = (context: NoContext = {}) =>
  PartnerUserInvitationAccept(context)
